import {IFreePlayVoucherViewModel} from "./vouchers/free-play-voucher-view-model.interface";

export enum FreePlayStatus {
    Created = 1,
    Active = 5,
    Canceled = 9,
    Expired = 10,
    Finished = 16
}

export interface IFreePlayService {
    readonly userVouchers: IFreePlayVoucherViewModel[];
    readonly hasVouchers: boolean;
    findVoucherById(id: string): IFreePlayVoucherViewModel | null
    getGameVouchers(gameType: number): IFreePlayVoucherViewModel[];
    refreshVouchers(): Promise<void>;
    registerActionToExecuteWhenFreePlayIsAvailable(action: () => Promise<void>): void;
}